const BottomFlap = () => (
    <svg
        className="bottom-flap"
        viewBox="0 0 536 544"
        preserveAspectRatio="none"
    >
        <path
            d="
                M 0 544
                L 536 544
                L 536 289
                L 312 69
                L 224 69
                L 0 289
                Z
            "
            fill="currentColor"
        />
    </svg>
);

export default BottomFlap;